module.exports = __webpack_public_path__ + "static/media/terminology-customer.241d0713.svg";